/* Free From Direct: collection page-size preference, v1.1 (reload fix). */
(() => {
  const elementName = 'ffd-page-size';
  if (customElements.get(elementName)) return;

  const attributeName = 'ffd_products_per_page';
  const storageKey = 'ffd:collection-page-size';
  const allowedSizes = ['36', '50', '100'];

  class FFDPageSize extends HTMLElement {
    static saving = false;

    connectedCallback() {
      this.select = this.querySelector('select');
      this.status = this.querySelector('[data-page-size-status]');
      if (!this.select || !this.status) return;
      this.onChange = this.onChange || this.changeSize.bind(this);
      this.select.addEventListener('change', this.onChange);
      this.hidden = false;
      this.select.disabled = FFDPageSize.saving;
      this.status.textContent = FFDPageSize.saving ? 'Updating productsâ€¦' : '';
      if (!FFDPageSize.saving) FFDPageSize.remember(this.dataset.pageSize);
    }

    disconnectedCallback() {
      if (this.select && this.onChange) this.select.removeEventListener('change', this.onChange);
    }

    static remember(value) {
      try {
        sessionStorage.setItem(storageKey, value);
      } catch (_) {
        // The cart attribute remains the source of truth if storage is blocked.
      }
    }

    static setState(busy, message = '', restoreSelection = false) {
      FFDPageSize.saving = busy;
      document.querySelectorAll(elementName).forEach((control) => {
        const select = control.querySelector('select');
        const status = control.querySelector('[data-page-size-status]');
        control.setAttribute('aria-busy', String(busy));
        if (select) {
          select.disabled = busy;
          if (restoreSelection) select.value = control.dataset.pageSize;
        }
        if (status) status.textContent = message;
      });
    }

    static firstPageURL() {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      // Preserve sorting, repeated filter parameters and theme preview parameters.
      url.hash = 'ProductGridContainer';
      return url.href;
    }

    static navigateToFirstPage(replace = false) {
      const current = new URL(window.location.href);
      const target = new URL(FFDPageSize.firstPageURL());
      const sameDocument = current.origin === target.origin &&
        current.pathname === target.pathname && current.search === target.search;

      if (sameDocument) {
        // Changing only a #fragment does not reload Shopify's rendered HTML.
        // Set the scroll anchor without navigation, then explicitly reload.
        try {
          window.history.replaceState(window.history.state, '', target.href);
        } catch (_) {
          // Reload even if the browser does not allow the history update.
        }
        window.location.reload();
      } else if (replace) {
        window.location.replace(target.href);
      } else {
        window.location.assign(target.href);
      }
    }

    async changeSize() {
      const value = this.select.value;
      if (FFDPageSize.saving || !allowedSizes.includes(value)) return;
      if (value === this.dataset.pageSize) return;

      FFDPageSize.setState(true, 'Updating productsâ€¦');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const root = window.Shopify?.routes?.root || this.dataset.routesRoot || '/';
        const response = await fetch(`${root.replace(/\/?$/, '/')}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // Only this display preference is submitted. No line items, notes or discounts.
          body: JSON.stringify({ attributes: { [attributeName]: value } }),
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Preference update failed');
        const cart = await response.json();
        if (String(cart.attributes?.[attributeName]) !== value) {
          throw new Error('Preference was not confirmed');
        }
        FFDPageSize.remember(value);
        // A full navigation clears the theme's in-memory facet HTML cache and
        // initializes existing quick-add components through the normal page load.
        FFDPageSize.navigateToFirstPage();
      } catch (_) {
        FFDPageSize.setState(false, 'Could not change the number of products. Please try again.', true);
      } finally {
        clearTimeout(timeout);
      }
    }
  }

  customElements.define(elementName, FFDPageSize);

  // A browser Back/Forward cache can restore HTML from before a size change.
  // Re-render page 1 with the saved preference instead of showing stale page offsets.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const control = document.querySelector(elementName);
    if (!control) return;
    FFDPageSize.setState(false, '', true);
    try {
      const rememberedSize = sessionStorage.getItem(storageKey);
      if (allowedSizes.includes(rememberedSize) && rememberedSize !== control.dataset.pageSize) {
        FFDPageSize.navigateToFirstPage(true);
      }
    } catch (_) {
      // Storage is optional; normal server navigation still uses the cart preference.
    }
  });
})();